import { Controller } from "stimulus"
import Swal from "sweetalert2";
export default class extends Controller {
  static targets = ["lockButton"]

  connect() {
    this.lockStacksUrl =
      document.location.origin + this.data.get("lockStacksPath");
    this.selectedItems = []
    this.allSelected = false
  }

  toggle(event) {
    const checkbox = event.target
    const stackId = checkbox.dataset.stackId
    const formVersionId = checkbox.dataset.formVersionId

    const exists = this.selectedItems.find(
      (item) => item.stackId === stackId && item.formVersionId === formVersionId
    )

    if (checkbox.checked && !exists) {
      this.selectedItems.push({ stackId, formVersionId })
    } else if (!checkbox.checked && exists) {
      this.selectedItems = this.selectedItems.filter(
        (item) => !(item.stackId === stackId && item.formVersionId === formVersionId)
      )
    }

    this.updateLockButtonState()
  }

  toggleAll(event) {
    const checked = event.target.checked
    const checkboxes = this.element.querySelectorAll(".stack-checkbox")

    checkboxes.forEach((checkbox) => {
      if (checkbox.disabled) return // 🚀 skip disabled ones
      checkbox.checked = checked

      const stackId = checkbox.dataset.stackId
      const formVersionId = checkbox.dataset.formVersionId

      const exists = this.selectedItems.find(
        (item) => item.stackId === stackId && item.formVersionId === formVersionId
      )

      if (checked && !exists) {
        this.selectedItems.push({ stackId, formVersionId })
      } else if (!checked && exists) {
        this.selectedItems = this.selectedItems.filter(
          (item) => !(item.stackId === stackId && item.formVersionId === formVersionId)
        )
      }
    })

    this.allSelected = checked
    this.updateLockButtonState()
  }

  updateLockButtonState() {
    if (this.hasLockButtonTarget) {
      this.lockButtonTarget.disabled = this.selectedItems.length === 0
    }
  }

lockSelected() {
  if (this.selectedItems.length === 0) {
    Swal.fire({
      icon: "warning",
      title: "No Selection",
      text: "Please select at least one record to lock.",
      confirmButtonColor: "#3085d6"
    });
    return;
  }

  Swal.fire({
    icon: "warning",
    title: "Are you sure you want to lock these visit completely?",
    html: `
      <div style="display: flex; justify-content: center; margin-top: 15px;">
        <label style="display: flex; align-items: center; gap: 8px; font-size: 14px;">
          <input type="checkbox" id="confirmLockCheckbox">
          DATA TRANSFER: LOCK THE VISIT COMPLETELY!
        </label>
      </div>
    `,
    showCancelButton: true,
    confirmButtonText: "Yes, Lock it!",
    cancelButtonText: "Cancel",
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    preConfirm: () => {
      if (!document.getElementById("confirmLockCheckbox").checked) {
        Swal.showValidationMessage("Please acknowledge the consequences to lock...");
        return false;
      }
    }
  }).then((result) => {
    if (result.isConfirmed) {
      // Proceed with fetch if confirmed
      fetch(this.lockStacksUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "X-CSRF-Token": document.head
            .querySelector('meta[name="csrf-token"]')
            .getAttribute("content"),
        },
        body: JSON.stringify({ stacks: this.selectedItems })
      })
        .then(response => {
          if (!response.ok) throw new Error("Network response was not ok");
          return response.json();
        })
        .then(data => {
          Swal.fire({
            icon: "success",
            title: "Locked!",
            text: data.message || "Stacks have been locked successfully.",
            confirmButtonColor: "#3085d6"
          }).then(() => {
            location.reload();
          });
        })
        .catch(error => {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Something went wrong while locking stacks.",
            confirmButtonColor: "#d33"
          });
        });
    }
  });
}




  updateLockButtonState() {
  if (this.hasLockButtonTarget) {
    const hasSelection = this.selectedItems.length > 0
    this.lockButtonTarget.disabled = !hasSelection
    this.lockButtonTarget.title = hasSelection
      ? "Lock selected records"
      : "Please select record(s) to lock"
  }
}

}
